module.exports = __webpack_public_path__ + "img/magazine.54026dde.png";